import { render, staticRenderFns } from "./taskDataUpload.vue?vue&type=template&id=55e1dfe1&"
import script from "./taskDataUpload.vue?vue&type=script&lang=js&"
export * from "./taskDataUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports